<template>
  <footer class="investment_fotter">
    <div class="investment_fotter_content">
      <div class="investment_qbcode">
        <ul>
          <!-- 123123123 -->
          <li>
            <img :src="first_qrcode" alt />
            <p>关注{{this.$store.state.siteName}}公众号</p>
          </li>
          <li>
            <img :src="second_qrcode" alt />
            <p>体验{{this.$store.state.siteName}}小程序</p>
          </li>
        </ul>
      </div>
      <div class="investment_center">
        <div class="investment_center_top">
          <ul>
            <li><router-link to="/">首页</router-link></li>
            <li><router-link to="/list">任务大厅</router-link></li>
            <li><router-link to="/investment" >招商加盟</router-link></li>
            <li><router-link to="/about" >关于我们</router-link></li>
          </ul>
        </div>
        <div class="investment_center_bot">
          <ul>
            <li>友情链接</li>
            <li
              class="curpot"
              v-for="(item,index) in this.friendship"
              :key="index"
              @click="goto2(index)"
            >{{item.name}}</li>
          </ul>
          <p>Copyright © {{this.$store.state.companyName}}</p>
        </div>
      </div>
      <div class="investment_rig">
        <img v-if="fotercon[0]" :src="this.fotercon[0].logo" alt />
        <img v-for="item in fotercon" :src="item" alt :key="item" />
      </div>
    </div>
  </footer>
</template>

<script>
import {
  gethomepc
} from "@/config/api.js";
export default {
  name: "fotter",
  data() {
    return {
      fotercon: [], //
      friendship: [], //
      foter_logo: [], //
      first_qrcode: '',
      second_qrcode: '',
    };
  },
  methods: {
    goto2(i) {
      window.open("http://" + this.friendship[i].url);
    },
    getInfo() {
      this.$post(gethomepc, { key: "pc_home_page" })
        .then(res => {
          let data = JSON.parse(res.data);
          this.first_qrcode = data.bottom.first_qrcode;
          this.second_qrcode = data.bottom.second_qrcode;
          // 底部友情链接数据
          this.fotercon.push(data.bottom.logo);
          let { bottom } = data;
          this.foter_logo.push(bottom.first_qrcode);
          this.foter_logo.push(bottom.second_qrcode);
          let { link } = data.bottom;
          for (let i = 0; i < link.length; i++) {
            this.friendship.push(link[i]);
          }
        })
        .catch(err => {
          window.console.log(err);
        });
    }
  },
  mounted() {
    this.getInfo();
  }
};
</script>

<style>
.investment_fotter {
  width: 100%;
  height: 387px;
  background: #2a2b31;
  margin-top: 40px;
}
.investment_fotter .investment_fotter_content {
  padding-top: 121px;
  position: relative;
  width: 1200px;
  height: 100%;
  margin: auto;
}
.investment_fotter .investment_fotter_content .investment_qbcode {
  float: left;
  width: 280px;
  height: 142px;
}
.investment_fotter .investment_fotter_content .investment_qbcode ul {
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.investment_fotter .investment_fotter_content .investment_qbcode ul li {
  text-align: center;
}
.investment_fotter .investment_fotter_content .investment_qbcode ul li p {
  margin-top: 6px;
  height: 16px;
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(204, 204, 204, 1);
  opacity: 1;
  text-align: center;
}
.investment_fotter .investment_fotter_content .investment_qbcode img{width: 120px;height:120px;}
.investment_fotter .investment_fotter_content .investment_center {
  float: left;
  width: 344px;
  height: 153px;
  margin-left: 60px;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
}
.investment_fotter
  .investment_fotter_content
  .investment_center
  .investment_center_top
  ul {
  display: flex;
  flex: 1;
  justify-content: space-between;
}
.investment_fotter
  .investment_fotter_content
  .investment_center
  .investment_center_top
  ul {
  font-size: 15px;
  line-height: 21px;
  color: rgba(204, 204, 204, 1);
  opacity: 1;
}
.investment_fotter
  .investment_fotter_content
  .investment_center
  .investment_center_bot
  ul {
  display: flex;
  flex: 1;
  justify-content: space-between;
  width: 218px;
}
.investment_fotter .investment_fotter_content .investment_center ul li a {
  color: #ccc;
}
.investment_fotter .investment_fotter_content .investment_center ul li a:hover {
  color: #FF741F;
}
.investment_fotter
  .investment_fotter_content
  .investment_center
  .investment_center_bot
  ul {
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  color: rgba(143, 143, 143, 1);
  opacity: 1;
}
.investment_fotter
  .investment_fotter_content
  .investment_center
  .investment_center_bot
  p {
  font-size: 12px;
  margin-top:10px;
  line-height: 24px;
  color: rgba(143, 143, 143, 1);
  opacity: 1;
}
.investment_fotter .investment_fotter_content .investment_rig {
  float: right;
}
.investment_fotter .investment_fotter_content .investment_rig {
  width: 194px;
  height: 46px;
  margin-top: 100px;
}
.curpot {
  transition: all 0.6s;
  cursor: pointer;
}
.curpot:hover {
  color: #ff9203;
}
</style>
